const Shift = {

    // FIELDS
    "shift": "Shift",
    "name": "Name",
    "description": "Description",
    "start_time": "Start Time",
    "end_time": "End Time",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Shift",
    "filter_title": "Shift Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_start_time": "Start Time",
    "table_end_time": "End Time",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Shift Name",
    "error_description": "Enter Description",
    "error_start_time": "Enter Start Time",
    "error_end_time": "Enter End Time",
    "error_status": "Select Status",

}

export default Shift;

